import { useState } from 'react';
import { FileText, ShoppingCart, HandCoins, TrendingUp } from 'lucide-react';
import { GrantsTab } from './grants/GrantsTab';
import { InvoicesTab } from './grants/InvoicesTab';
import { FundingDashboard } from './funding/FundingDashboard';
import InvestmentsListPage from '../pages/InvestmentsListPage';

export function GrantsManagement() {
  const [activeTab, setActiveTab] = useState<'grants' | 'invoices' | 'funding' | 'investments'>('grants');

  return (
    <div className="space-y-6">
      {/* Tabs */}
      <div className="border-b border-gray-200">
        <nav className="-mb-px flex space-x-8">
          <button
            onClick={() => setActiveTab('grants')}
            className={`flex items-center gap-2 py-4 px-1 border-b-2 font-medium text-sm transition-colors ${
              activeTab === 'grants'
                ? 'border-emerald-500 text-emerald-600'
                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
            }`}
          >
            <FileText className="w-5 h-5" />
            Subventions d'investissement
          </button>
          <button
            onClick={() => setActiveTab('invoices')}
            className={`flex items-center gap-2 py-4 px-1 border-b-2 font-medium text-sm transition-colors ${
              activeTab === 'invoices'
                ? 'border-emerald-500 text-emerald-600'
                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
            }`}
          >
            <ShoppingCart className="w-5 h-5" />
            Achats / Factures
          </button>
          <button
            onClick={() => setActiveTab('funding')}
            className={`flex items-center gap-2 py-4 px-1 border-b-2 font-medium text-sm transition-colors ${
              activeTab === 'funding'
                ? 'border-emerald-500 text-emerald-600'
                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
            }`}
          >
            <HandCoins className="w-5 h-5" />
            Financeurs
          </button>
          <button
            onClick={() => setActiveTab('investments')}
            className={`flex items-center gap-2 py-4 px-1 border-b-2 font-medium text-sm transition-colors ${
              activeTab === 'investments'
                ? 'border-emerald-500 text-emerald-600'
                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
            }`}
          >
            <TrendingUp className="w-5 h-5" />
            Plan d'Investissement
          </button>
        </nav>
      </div>

      {/* Tab content */}
      <div>
        {activeTab === 'grants' && <GrantsTab />}
        {activeTab === 'invoices' && <InvoicesTab />}
        {activeTab === 'funding' && <FundingDashboard />}
        {activeTab === 'investments' && <InvestmentsListPage />}
      </div>
    </div>
  );
}
